import { getCookie } from 'stash/utils/cookies';
import { getSuperCookie } from 'stash/utils/superCookie';

type AttributionKey =
	| 'fbclid'
	| '_fbp'
	| '_fbc'
	| 'gclid'
	| 'ttclid'
	| 'irclickid'
	| 'rdt_cid'
	| 'utm_medium'
	| 'utm_source'
	| 'utm_campaign'
	| 'utm_content'
	| 'utm_term'
	| 'utm_provider';

export type InstrumentationProperties = {
	fbclid?: string;
	_fbp?: string;
	_fbc?: string;
	gclid?: string;
	ttclid?: string;
	irclickid?: string;
	rdt_cid?: string;
	utm_medium?: string;
	utm_source?: string;
	utm_campaign?: string;
	utm_content?: string;
	utm_term?: string;
	utm_provider?: string;
	frontend_platform: 'web';
};

export const getInstrumentationProperties = (): InstrumentationProperties => {
	const superCookie = getSuperCookie();
	const pickAttributionValue = (key: AttributionKey): string | undefined =>
		superCookie?.[key] || getCookie(key) || undefined;
	const fbclid = pickAttributionValue('fbclid');
	const fbp = pickAttributionValue('_fbp');
	const fbc = pickAttributionValue('_fbc');
	const gclid = pickAttributionValue('gclid');
	const ttclid = pickAttributionValue('ttclid');
	const irclickid = pickAttributionValue('irclickid');
	const rdt_cid = pickAttributionValue('rdt_cid');
	const utm_medium = pickAttributionValue('utm_medium');
	const utm_source = pickAttributionValue('utm_source');
	const utm_campaign = pickAttributionValue('utm_campaign');
	const utm_content = pickAttributionValue('utm_content');
	const utm_term = pickAttributionValue('utm_term');
	const utm_provider = pickAttributionValue('utm_provider');

	return {
		...(fbclid && { fbclid: `fb.1.${Date.now()}.${fbclid}` }),
		...(fbp && { _fbp: fbp }),
		...(fbc && { _fbc: fbc }),
		...(gclid && { gclid }),
		...(ttclid && { ttclid }),
		...(irclickid && { irclickid }),
		...(rdt_cid && { rdt_cid }),
		...(utm_medium && { utm_medium }),
		...(utm_source && { utm_source }),
		...(utm_campaign && { utm_campaign }),
		...(utm_content && { utm_content }),
		...(utm_term && { utm_term }),
		...(utm_provider && { utm_provider }),
		frontend_platform: 'web',
	};
};
